import { KeyboardArrowLeftOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getUserEmailAddress } from 'src/keycloak';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

type ISelfSignupConfirmationProps = {
  handleBackBtn: () => void;
};

const SelfSignupConfirmation = ({
  handleBackBtn
}: ISelfSignupConfirmationProps) => {
  const { t } = useTranslation();
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          padding: '10px',
          cursor: 'pointer',
          width: '20%'
        }}
        onClick={handleBackBtn}
      >
        <KeyboardArrowLeftOutlined />
        <Typography sx={{ textDecoration: 'underline' }}>
          {t(T.back)}
        </Typography>
      </Box>
      <Typography fontSize={'20px'} fontWeight={400} color={'primary'}>
        {t(T.selfSignupConfirmation2, { email: getUserEmailAddress() })}
      </Typography>
      <Typography>{t(T.selfSignupConfirmation3)}</Typography>
    </Box>
  );
};

export default SelfSignupConfirmation;
